import { yupResolver } from "@hookform/resolvers";
import React, { ChangeEventHandler, useContext, useEffect, useState } from "react";
import { Col, Form, Button, Spinner, Row } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import Customer from "../../../../../../Data/Customer/Customer";
import { ReservationCustomer } from "../../../../../../Data/Reservation/ReservationCustomer";
import { DatesAndGuests } from "../../../widget-form/WidgetForm";
import { RequestQuoteFormData, RequestQuoteSchema, RequestQuoteSchemaDefaultValues } from "../../widget-modals/schemas/RequestQuoteSchema";

interface props {
  // datesAndGuests: DatesAndGuests;
  requestItineraryQuote: (customers: ReservationCustomer[], groupName: string | undefined, fromBooking: boolean) => void;
  isLoading: boolean;
}

const GetQuote: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, datesAndGuests, companyId } = useContext(WidgetContext);

  const [travelerCount, setTravelerCount] = useState<number[]>([]);
  const { requestItineraryQuote, isLoading } = props;

  // const [validated, setValidated] = useState<boolean>(false);
  const { register, control, handleSubmit, errors, formState, setValue, reset, getValues } = useForm<RequestQuoteFormData>({
    mode: "onSubmit",
    resolver: yupResolver(RequestQuoteSchema),
    defaultValues: RequestQuoteSchemaDefaultValues
  });

  useFieldArray(
    {
      control,
      name: "travelers",
      keyName: "keyId",
    }
  );

  function submit(formData: RequestQuoteFormData) {
    const customers: ReservationCustomer[] = [];
    const customer: ReservationCustomer = {
      reservationId: 0,
      customerId: 0,
      customer: {
        companyId: companyId as number,
        customerId: 0,
        isActive: true,
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailAddress: formData.email,
        streetAddress: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        phone1: formData.phone,
        customerNotes: formData.comments,
      },
      paymentAllocationCategoryId: undefined,
      paymentAllocationCategory: undefined,
      cancelled: false
    };

    customers.push(customer);

    if (formData.travelers !== undefined) {
      formData.travelers.forEach(t => {
        const traveler: ReservationCustomer = {
          reservationId: 0,
          customerId: 0,
          customer: {
            companyId: companyId as number,
            customerId: 0,
            isActive: true,
            firstName: t.firstName,
            lastName: t.lastName,
            emailAddress: t.email,
            streetAddress: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            phone1: "",
            customerNotes: "",
          },
          paymentAllocationCategoryId: undefined,
          paymentAllocationCategory: undefined,
          cancelled: false
        };

        customers.push(traveler);
      });
    }

    requestItineraryQuote(customers, formData.groupName, false);
  }

  useEffect(() => {
    if (errors)
      console.log("form errors", errors);
  }, [errors]);

  return (
    <React.Fragment>
      <div className="itinerary-font">
        <Col>
          {/* Travel / Party  */}
          <Col className="d-flex flex-row justify-content-start">
            <h4
              className="bold-text"
            >
              Contact Info
            </h4>
          </Col>

          <Form className="widget-font" noValidate onSubmit={handleSubmit(submit)}>
            <Form.Row>
              <Col>
                {/* <Form.Label style={{ fontWeight: "bold" }}>
                  First Name
                </Form.Label> */}
                <Form.Control
                  name="firstName"
                  type="text"
                  placeholder="First Name"
                  // value={firstName}
                  // onChange={textChange}
                  ref={register}
                  isValid={formState.isSubmitted && !errors.firstName}
                  isInvalid={formState.isSubmitted && (!!errors.firstName)}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.firstName && errors.firstName.message}
                </Form.Control.Feedback>
              </Col>
              <Col>
                {/* <Form.Label style={{ fontWeight: "bold" }}>
                  Last Name
                </Form.Label> */}
                <Form.Control
                  name="lastName"
                  type="text"
                  placeholder="Last Name"
                  // value={lastName}
                  // onChange={textChange}
                  ref={register}
                  isValid={formState.isSubmitted && !errors.lastName}
                  isInvalid={formState.isSubmitted && (!!errors.lastName)}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.lastName && errors.lastName.message}
                </Form.Control.Feedback>
              </Col>
            </Form.Row>
            <Form.Row style={{ marginTop: "15px" }}>
              <Col>
                {/* <Form.Label style={{ fontWeight: "bold" }}>
                  Email Address
                </Form.Label> */}
                <Form.Control
                  name="email"
                  type="text"
                  placeholder="Email Address"
                  // value={email}
                  // onChange={textChange}
                  ref={register}
                  isValid={formState.isSubmitted && !errors.email}
                  isInvalid={formState.isSubmitted && (!!errors.email)}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email && errors.email.message}
                </Form.Control.Feedback>
              </Col>
              <Col>
                {/* <Form.Label style={{ fontWeight: "bold" }}>
                  Contact Phone
                </Form.Label> */}
                <Form.Control
                  name="phone"
                  placeholder="Phone Number"
                  // value={phone}
                  // onChange={textChange}
                  ref={register}
                  isValid={formState.isSubmitted && !errors.phone}
                  isInvalid={formState.isSubmitted && (!!errors.phone)}
                />
                <Form.Control
                  hidden
                  placeholder="Email"
                  name="numGuests"
                  ref={register}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.phone && errors.phone.message}
                </Form.Control.Feedback>
              </Col>
            </Form.Row>

            <Form.Row style={{ marginTop: "15px" }}>
              <Col xs={6}>
                {/* <Form.Label style={{ fontWeight: "bold" }}>
                  Group Name
                </Form.Label> */}
                <Form.Control
                  required
                  name="groupName"
                  type="text"
                  placeholder="Group Name"
                  // value={groupName}
                  // onChange={textChange}
                  ref={register}
                  isValid={formState.isSubmitted && !errors.groupName}
                  isInvalid={formState.isSubmitted && (!!errors.groupName)}
                />

                {/* <Form.Control.Feedback type="invalid">
                          {errors.groupName && errors.firstName.message}
                        </Form.Control.Feedback> */}
              </Col>
            </Form.Row>

            {/* Comments */}
            <Col className="d-flex flex-row" style={{ marginTop: "20px" }}>
              <Col>
                {/* <Form.Label className="add-golf-label">Comments</Form.Label> */}
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="comments"
                  placeholder="Any comments, questions, or concerns? Leave them here and we'll be happy to help."
                  ref={register}
                  isValid={formState.isSubmitted && !errors.comments}
                  isInvalid={formState.isSubmitted && (!!errors.comments)}
                />
              </Col>
            </Col>

            {/* Send Itinerary to Your Friends */}
            {datesAndGuests.guests !== 1 &&
              <Col>
                <h4
                  className="bold-text"
                  style={{
                    marginTop: "20px",
                  }}
                >
                  Send Itinerary to Your Friends
                </h4>
              </Col>
            }

            {/* Co Traveler Form */}
            {travelerCount.map((a: number) =>
              <Form.Row className={`d-flex flex-row ${a > 0 ? "mt-2" : ""}`}>
                <Col>
                  {/* <Form.Label className="add-golf-label">First Name</Form.Label> */}
                  <Form.Control
                    placeholder="First Name"
                    name={`travelers[${a}].firstName`}
                    ref={register}
                  />
                </Col>
                <Col>
                  {/* <Form.Label className="add-golf-label">Last Name</Form.Label> */}
                  <Form.Control
                    placeholder="Last Name"
                    name={`travelers[${a}].lastName`}
                    ref={register}
                  />
                </Col>
                <Col>
                  {/* <Form.Label className="add-golf-label">
                    Email Address
                  </Form.Label> */}
                  <Form.Control
                    placeholder="Email"
                    name={`travelers[${a}].email`}
                    ref={register}
                  />
                </Col>
              </Form.Row>
            )}

            {travelerCount.length < datesAndGuests.guests - 1 &&
              <Col>
                <Button
                  className="co-traveler-button"
                  style={{
                    marginTop: "10px",
                  }}
                  onClick={() => { setTravelerCount([...travelerCount, travelerCount.length]); }}
                >
                  + Add co-traveler
                </Button>
              </Col>
            }



            {/* Button */}
            <Col style={{ marginTop: "20px" }}>
              <Button
                block
                type="submit"
                disabled={isLoading}
                className="orange-button"
                style={{ fontSize: "20px" }}
              >
                <Row className="justify-content-center align-items-center">
                  {isLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {isLoading ? "Saving..." : "Save & Get Quote"}
                </Row>
              </Button>
            </Col>
          </Form>
        </Col>
      </div>
    </React.Fragment>
  );
}

export default GetQuote;
